import * as React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Badge, IconButton, Tooltip } from '@mui/material'
import { AuthContext } from '../../core/context/AuthContext'
import { useChargebackDisputeAccess } from '../../core/context/TenantSettingsContext'
import ChargebackDisputeController from '../../core/controllers/ChargebackDisputeController'

export default function DisputeNotificationBell() {
  const { user, session, isUserSysAdmin } = React.useContext(AuthContext)
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const [count, setCount] = React.useState(0)
  const access = useChargebackDisputeAccess()
  // Igual ao menu: sysadmin dentro da conta de um produtor (session) conta como produtor
  const enabled =
    !!user && (!!session || !isUserSysAdmin()) && access === 'allowed'

  // Recarrega ao montar, a cada troca de rota e quando a janela volta ao foco
  React.useEffect(() => {
    if (!enabled) return
    let active = true
    const refresh = () =>
      ChargebackDisputeController.getOpenCount().then((value) => {
        if (active) setCount(value)
      })
    refresh()
    window.addEventListener('focus', refresh)
    return () => {
      active = false
      window.removeEventListener('focus', refresh)
    }
  }, [enabled, pathname])

  if (!enabled || count <= 0) return null

  const title =
    count === 1
      ? '1 chargeback aguardando contestação'
      : `${count} chargebacks aguardando contestação`

  return (
    <Tooltip title={title}>
      <IconButton
        aria-label={title}
        onClick={() => navigate('/disputes')}
        sx={{ mr: 1 }}
      >
        <Badge badgeContent={count} color="error" max={99}>
          <img src="/assets/icons/bell/bell.svg" alt="" width={24} height={24} />
        </Badge>
      </IconButton>
    </Tooltip>
  )
}
